import { SelectIF } from '@/types/common';

export type SizeT = 'Small' | 'Medium' | 'Large';

export const SIZES_PROPERTIES: SelectIF<SizeT>[] = [
    {
        value: 'Small',
        label: 'Маленький',
    },
    {
        value: 'Medium',
        label: 'Средний',
    },
    {
        value: 'Large',
        label: 'Большой',
    },
];
